import { gsap } from '../animations';

/**
 * Immagine opzionale del block "Intro testo": la foto "cresce" da scale 0.86
 * (angoli arrotondati) fino a toccare i bordi mentre la sezione entra. Stessi
 * parametri della presentazione, per coerenza. Nessun effetto senza immagine.
 */
export function initIntroTesto() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '[data-intro-stage]' ).forEach( ( stage ) => {
		gsap.fromTo(
			stage,
			{ scale: 0.86, borderRadius: '18px' },
			{
				scale: 1,
				borderRadius: '0px',
				ease: 'none',
				scrollTrigger: {
					trigger: stage,
					start: 'top bottom',
					end: 'center center',
					scrub: 0.5,
				},
			}
		);
	} );
}
